import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { ButtonComponent } from '../../common/components/button/button.component';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatTabsModule } from '@angular/material/tabs';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { AddModelDialogComponent } from './dialog/add-model-dialog/add-model-dialog.component';
import { AdminService } from '../../../services/admin.service';
import { ActiveInactiveModelDialogComponent } from './dialog/active-inactive-model-dialog/active-inactive-model-dialog.component';
import { ErrorNotficationComponent } from '../../../error-notfication/error-notfication.component';
import { LoaderComponent } from '../../common/components/loader/loader.component';

@Component({
  selector: 'app-model-configuration-mgmt',
  standalone: true,
  imports: [MatButtonModule, ButtonComponent, MatCardModule, MatFormFieldModule, MatInputModule, FormsModule, MatTabsModule, CommonModule, MatRadioModule, MatCheckboxModule, MatSlideToggleModule, MatDialogModule, LoaderComponent],
  templateUrl: './model-configuration-mgmt.component.html',
  styleUrl: './model-configuration-mgmt.component.scss'
})
export class ModelConfigurationMgmtComponent {

  checked = false;
  disabled = false;
  modelData: any;
  isUpdateModel: boolean = false;
  searchData: string = '';
  allModels: any = [];
  activeModels: any = [];
  inactiveModels: any = [];
  activeModelsMaster: any = [];
  inactiveModelMaster: any = [];
  
  isLoading: boolean = false;

  constructor(
    private adminService: AdminService,
    private dialog: MatDialog,
  ) {
    
  }

  ngOnInit() {
    this.getAllModels();
  }

  getAllModels() {
    
    this.isLoading = true;
    this.adminService.getAllModels().subscribe((resp:any) => {
      this.isLoading = false;
      // this.modelData = this.adminService.getAllModels();
      // this.allModels = JSON.parse(JSON.stringify(this.modelData.data));



      let models: any = resp.data;

      this.allModels = JSON.parse(JSON.stringify(models));

      this.activeModelsMaster = this.allModels.filter((item:any) => item.is_active);
      this.activeModels = JSON.parse(JSON.stringify(this.activeModelsMaster));
      this.inactiveModelMaster = this.allModels.filter((item:any) => !item.is_active);
      this.inactiveModels = JSON.parse(JSON.stringify(this.inactiveModelMaster))
 
      

      
    }, (error) => {
      this.isLoading = false;
      this.openSnackbar(error?.error?.message, 'An error occurred', 'error-snackbar');
      console.error('Error getting categories list:', error);
    })
  }

  addUpdateModel(data?:any) {
 
    if (data) {
      data.isUpdateModel = this.isUpdateModel;
    }
    const dialogRef = this.dialog.open(AddModelDialogComponent, {
      data: data ? data : '',
      maxWidth: '472px',
      width: '100%',
      disableClose: true
    });
    
    dialogRef.afterClosed().subscribe((resp:any) => {
      this.isUpdateModel = false;
      if(resp) {
        if(!data) {
          this.isLoading = true;
          this.adminService.createModel(resp).subscribe((item:any) => {
            this.isLoading = false;
           
            this.openSnackbar("Model created successfully", 'Created Successfully', 'success-snackbar');
            this.getAllModels();
          }, (error) => {
            this.isLoading = false;
            this.openSnackbar(error?.error?.message, 'An error occurred', 'error-snackbar');
          })
        } else {
          this.isLoading = true;
          this.adminService.updateModel(data.id,resp).subscribe((updatedItem:any) => {
            this.isLoading = false;
           
            this.openSnackbar("Model updated successfully", 'Updated Successfully', 'success-snackbar');
            this.getAllModels();
          }, (error) => {
            this.isLoading = false;
            this.openSnackbar(error?.error?.message, 'An error occurred', 'error-snackbar');
          })
        }
      }
    })
  }

  aciveInactiveModel(model:any, event:any) {
   
    const originalState = model.is_active;
    const dialogRef = this.dialog.open(ActiveInactiveModelDialogComponent, {
      data: model,
      maxWidth: '472px',
      width: '100%',
      disableClose: true
    });
    dialogRef.afterClosed().subscribe((resp:any) => {
     
      if (resp) {
        model.is_active = resp.is_active;
        // event.source.checked = resp.is_active;
        const postData = {
          is_active: resp.is_active
        }
        this.isLoading = true;
        this.adminService.updateModel(model.id,postData).subscribe((updatedItem:any) => {
          this.isLoading = false;
          
          if (postData.is_active) {
            this.openSnackbar("Model Activated successfully", 'Updated Successfully', 'success-snackbar');
          } else {
            this.openSnackbar("Model Deactivated successfully", 'Updated Successfully', 'success-snackbar');
          }
          this.getAllModels();
        }, error => {
          this.isLoading = false;
          this.openSnackbar(error?.error?.message, 'An error occurred', 'error-snackbar');
          
          
        })
      } else {
        model.is_active = originalState;
       
        
        // event.source.checked = originalState;
        if (event && event.source) {
          event.source.checked = originalState;  // Restore the original toggle state
        }
      }
    })
  }

  updateModel(model:any) {
    
    this.isUpdateModel = true;
    this.addUpdateModel(model)
  }

  onSearch(data:any) {
  
    
    const searchQuery = this.searchData.toLowerCase().trim();

    if (searchQuery) {
      this.activeModels = this.activeModelsMaster.filter((cat:any) =>
        cat.name.toLowerCase().includes(searchQuery) || cat.cloud_model.toLowerCase().includes(searchQuery) || cat.value.toLowerCase().includes(searchQuery)
      );
      this.inactiveModels = this.inactiveModelMaster.filter((cat:any) =>
        cat.name.toLowerCase().includes(searchQuery) || cat.cloud_model.toLowerCase().includes(searchQuery) || cat.value.toLowerCase().includes(searchQuery)
      );
    } else {
      this.getAllModels();
    }
  }

  clearSearch() {
    this.searchData = '';
    this.getAllModels();
  }

  onValueChange() {
    if(!this.searchData) {
      this.getAllModels();
    }
  }

  openSnackbar(message: string, title: string, cssClass: string) {
      const dialogRef = this.dialog.open(ErrorNotficationComponent, {
        data: {
          message: message,
          title: title,
          action_type: 'add',
          cssClass: cssClass
        }
      });
  }

}
